import { AbstractIdbaModel } from "../abstract-idba-model";


export class ParametrosGenericos extends AbstractIdbaModel {

    public override display(self: any): string {
        return self.assunto;
    }
    public override displayCodigo(self: any): string {
        throw new Error("Method not implemented.");
    }
    public override displayNome(self: any): string {
        throw new Error("Method not implemented.");
    }
    public override convertToModel(data: any): AbstractIdbaModel {
        return new ParametrosGenericos(data);
    }
    public override filter(value: string, objectList: any[]): any[] {
        throw new Error("Method not implemented.");
    }
    codigoParGenerico: number;
    assunto: string;
    codigoLocal: number;
    nomeLocal: string;
    valor: string;
    codigoModulo: number;
    abrevModulo: string;
    descModulo: string;

}
